import {AxiosResponse} from 'axios';
import moment from 'moment/moment';

import {IProjectInfluenceItemForm} from '../model/project-investment-info-item-modal.types';

const mapTerritories = (data: any) => {
    if (Array.isArray(data?.territories)) {
        return data.territories;
    }
    if (data?.cadastralNumber || data?.propertyType || data?.regionCode) {
        return [{
            cadastralNumber: data?.cadastralNumber,
            propertyType: data?.propertyType,
            regionCode: data?.regionCode,
        }];
    }
    return [];
};

const mapBenefitItem = (item: any) => ({
    ...item,
    benefitBaseDocumentDate: item?.benefitBaseDocumentDate
        ? moment(item.benefitBaseDocumentDate)
        : undefined,
});

const mapBenefits = (data: any) => {
    if (Array.isArray(data?.benefits)) {
        return data.benefits.map(mapBenefitItem);
    }
    if (data?.benefitTypeGovSupport || data?.benefitBaseDocumentType) {
        return [mapBenefitItem({
            benefitTypeGovSupport: data?.benefitTypeGovSupport,
            benefitTypeDescription: data?.benefitTypeDescription,
            benefitTypeBenefitDetail: data?.benefitTypeBenefitDetail,
            benefitBaseDocumentType: data?.benefitBaseDocumentType,
            benefitBaseDocumentTypeDescription: data?.benefitBaseDocumentTypeDescription,
            benefitBaseDocumentAuthority: data?.benefitBaseDocumentAuthority,
            benefitBaseDocumentDate: data?.benefitBaseDocumentDate,
            benefitBaseDocumentNumber: data?.benefitBaseDocumentNumber,
            benefitBaseDocumentDetail: data?.benefitBaseDocumentDetail,
            socialConstructionCommitment: data?.socialConstructionCommitment,
            socialConstructionCommitmentDescription: data?.socialConstructionCommitmentDescription,
        })];
    }
    return [];
};

export const convertResponseToProjectInfluenceItemForm = (response: AxiosResponse) => (
    {
        projectInfo: response?.data?.projectInfo,
        investProjectCountry: response?.data?.investProjectCountry,
        okvedCode: response?.data?.okvedCode,
        activityDirection: response?.data?.activityDirection,
        investProjectTarget: response?.data?.investProjectTarget,
        investBaseDocumentType: response?.data?.investBaseDocumentType,
        startPlanYear: response?.data?.startPlanYear,
        startFactYear: response?.data?.startFactYear,
        operationPlanYear: response?.data?.operationPlanYear,
        operationFactYear: response?.data?.operationFactYear,
        investBaseDocumentDescription: response?.data?.investBaseDocumentDescription,
        investBaseDocumentDate: moment(response?.data?.investBaseDocumentDate),
        investBaseDocumentNumber: response?.data?.investBaseDocumentNumber,
        isInternational: response?.data?.isInternational,
        territories: mapTerritories(response?.data),
        hasBenefit: response?.data?.hasBenefit,
        benefits: mapBenefits(response?.data),
        targetIndicators: response?.data?.targetIndicators,
        finSources: response?.data?.finSources,
        investors: response?.data?.investors,
        financialIndicators: response?.data?.financialIndicators,
        orgId: response?.data?.orgId,
        id: response?.data?.id,
    } as IProjectInfluenceItemForm
);
